var render = function () {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.newsStatus
    ? _c(
        "div",
        { staticClass: "news" },
        [
          _c("h2", { staticStyle: { display: "block" } }, [_vm._v("Новости")]),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { id: "news-wrapper" } },
            _vm._l(_vm.newsList, function (e, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass: "column uk-width-1-2",
                  style: {
                    boxShadow: e.img ? "#aaa 0px 5px 15px" : 0,
                    cursor: e.text ? "pointer" : "default",
                    backgroundColor: e.img ? "#fff" : "transparent",
                  },
                  on: {
                    click: function () {
                      _vm.showSingleNewsModal(e.text, e.img, e.date)
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "wrapper",
                      style: { padding: e.img ? "0" : "15px !important" },
                    },
                    [
                      _c("div", {
                        staticClass: "single-news-img",
                        style: {
                          "background-image": e.img
                            ? "url(" + e.img + ")"
                            : "unset",
                          height: e.img ? "200px" : 0,
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "p",
                        {
                          staticClass: "date",
                          style: { padding: e.img ? "5px 0 0 15px" : "0" },
                        },
                        [_vm._v(_vm._s(_vm.date_format(e.date, true)))]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { style: { padding: e.img ? "0 15px 10px" : "0" } },
                        [
                          _c("p", {
                            staticClass: "single-news-text",
                            domProps: { innerHTML: _vm._s(e.title) },
                          }),
                          _vm._v(" "),
                          e.text
                            ? _c("p", { staticClass: "show-single-news" }, [
                                _vm._v("Подробнее"),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _vm.newsList.length < _vm.newsTotal
            ? _c(
                "div",
                {
                  attrs: { id: "news-show-more" },
                  on: {
                    click: function ($event) {
                      return _vm.getNews()
                    },
                  },
                },
                [_vm._v("Показать ещё")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showModal
            ? _c(
                "modal",
                {
                  attrs: {
                    close: function () {
                      _vm.closeModalClickHandle()
                    },
                    customInnerWidth: "875px",
                    customInnerHeight: "auto",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "news__modal-header",
                      attrs: { slot: "modalHeader" },
                      slot: "modalHeader",
                    },
                    [
                      _c("div", { staticClass: "news__modal-date" }, [
                        _vm._v(_vm._s(_vm.date_format(_vm.modalDate, true))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "news__modal-body",
                      attrs: { slot: "modalBody" },
                      slot: "modalBody",
                    },
                    [
                      _vm.modalImg
                        ? _c("div", {
                            staticClass: "news__modal-screenshot",
                            style: {
                              background:
                                "url(" +
                                _vm.modalImg +
                                ") no-repeat scroll top center",
                              backgroundSize: "cover",
                              height: _vm.modalImg ? "400px" : "auto",
                            },
                            on: { click: _vm.clickBigScreenShot },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c("p", {
                        staticClass: "news__modal-text",
                        domProps: { innerHTML: _vm._s(_vm.modalText) },
                      }),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showFullScreenImg
            ? _c("img", {
                staticClass: "imageView",
                attrs: { src: _vm.modalImg },
                on: {
                  click: function () {
                    this$1.showFullScreenImg = false
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }